// **  Initial State
const initialState = {
	data: {
		global_list: []
	},
	loading: false
}

export const resourcesReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'DASHBOARD_SET_INFO':
			return {
				...state,
				data: {
					...state.data,
					...action.data
				}
			}
		case 'SET_GLOBAL_LIST':
			const editState = _.cloneDeep(state)
			editState.data.global_list = action.payload
			return editState
		case 'DASHBOARD_INFO_LOADING_START':
			return {
				...state, loading: true
			}
		case 'DASHBOARD_INFO_LOADING_END':
			return {
				...state, loading: false
			}
		default:
			return state
	}
}
